import(/* webpackMode: "eager" */ "/builds/Instacover/instaclaim-instacar/apps/crossroad/src/app/docs/page.tsx");
